import React, { useEffect, useRef } from "react";
import classnames from "classnames";
import { Text } from "../text/Text";
import { IIconProps } from "../icons/Icons";
import "./Input.scss";

interface IInput {
  autofocus: boolean;
  className: string;
  Icon: (props: IIconProps) => JSX.Element;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  onIconClick?: React.MouseEventHandler<HTMLDivElement>;
  placeholder: string;
  type?: string;
  validationMsg?: string | null | undefined;
  value?: string | number | readonly string[] | undefined;
  triggerFocus?: boolean | undefined;
  clearValue?: boolean | undefined;
}

export const Input = (props: IInput) => {
  const {
    autofocus,
    className,
    Icon,
    onChange,
    onIconClick,
    placeholder,
    type = "text",
    validationMsg,
    value,
    triggerFocus,
    clearValue,
  } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (autofocus) {
      inputRef.current?.focus();
    }
  }, [autofocus]);

  useEffect(() => {
    if (clearValue != null && inputRef.current) {
      inputRef.current.value = "";
    }
  }, [clearValue]);

  useEffect(() => {
    if (triggerFocus != null) {
      inputRef.current?.focus();
    }
  }, [triggerFocus]);

  return (
    <div className={classnames("input-container", className)}>
      <input
        className={classnames("input", {
          invalid: validationMsg,
        })}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(e)}
        placeholder={placeholder}
        ref={inputRef}
        type={type}
        value={value}
      />
      {Icon ? <Icon onClick={onIconClick} /> : null}
      {validationMsg ? <Text lKey={validationMsg} className="validation-message" /> : null}
    </div>
  );
};
